import { useState, useEffect, useCallback } from "react";
import React from "react";
import axios from "axios";
import {
  FiPlus,
  FiSearch,
  FiEye,
  FiEdit2,
  FiMoreHorizontal,
  FiCheckCircle, FiXCircle
} from "react-icons/fi";
import Modal from "../components/modal";
import Notification from "../components/Notification";
import { getAllRoles, getAllBranch } from "../api/reusableApis";
import Popover from "../components/ui/Popover";



export default function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("All");
  const [roles, setRoles] = useState([]);
  const [branch, setBranch] = useState([]);
  // const [selectedIds, setSelectedIds] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    branch: "",
    phone: "",
    dob: "",
    status: "",
  });
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({ message: "", type: "success" });
  const [loader, setLoader] = useState(true);
  // const [openMenuId, setOpenMenuId] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const isEditMode = mode === "edit";

  const headers_obj = {
    headers: {
      'ZCFKEY': apiKey
    }
  }
  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const res = await axios.get(apiUrl + "/getUsers?branch_id=ALL", headers_obj);
      const mappedUsers = res.data.users.map((u) => ({
        id: u.ROWID,
        first_name: u.name,
        last_name: u.lastName,
        name: `${u.name} ${u.lastName}`,
        email: u.email,
        role: u?.role_name || "User",
        status: u.is_active ? "Active" : "Inactive",
        user_type: u.user_type,
        avatar:
          !u.user_img_url || u.user_img_url === ""
            ? `https://ui-avatars.com/api/?name=${u.name}+${u.lastName}`
            : u.user_img_url,
        branch: u.branch_id || "",
        user_id: u.user_id || "",
        phone: u.phone || "",
        dob: u.dateOfBirth || "",
        is_confirmed: u.user_management?.is_confirmed ? "Yes" : "No",
      }));
      setUsers(mappedUsers);
      setLoader(false);
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, [apiUrl]);

  const fetchRoles = useCallback(async () => {
    try {
      setLoader(true);
      const roles = await getAllRoles();
      setRoles(roles);
      setLoader(false);
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  const fetchBranch = useCallback(async () => {
    try {
      setLoader(true);
      const branches = await getAllBranch(true);
      setBranch(branches);
      setLoader(false);
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  // const toggleMenu = (id) => {
  //   setOpenMenuId(openMenuId === id ? null : id);
  // };


  // const handleClickOutside = (event) => {
  //   if (!event.target.closest(".user-menu") && !event.target.closest(".menu-trigger")) {
  //     setOpenMenuId(null);
  //   }
  // };

  useEffect(() => {
    fetchUsers();
    fetchRoles();
    fetchBranch();

    // document.addEventListener("mousedown", handleClickOutside);
    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, []);


  // filter users based on search and role
  const filteredUsers = users.filter((u) => {
    const matchesSearch =
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase());
    const matchesRole = role === "All" || u.role === role;
    return matchesSearch && matchesRole;
  });


  // validation
  const validateForm = () => {
    const tempErrors = {};
    if (!formData.firstName.trim()) tempErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) tempErrors.lastName = "Last name is required";
    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      tempErrors.email = "Invalid email address";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const openModalForUser = (user, type) => {
    setSelectedUser(user);
    setFormData({
      firstName: user?.first_name || "",
      lastName: user?.last_name || "",
      email: user?.email || "",
      role: user?.role || "",
      branch: user?.branch || "",
      phone: user?.phone || "",
      dob: user?.dob || "",
      status: user?.status || "",
    });
    setErrors({});
    setMode(type);
    setOpenModal(true);
  };

  const handleView = (user) => openModalForUser(user, "view");
  const handleEdit = (user) => openModalForUser(user, "edit");

  const handleDelete = async (user) => {
    if (!window.confirm("Deactivate this user?")) return;

    try {
      const res = await axios.post(apiUrl + "disableUser", {
        userId: user.user_id,
      }, headers_obj);

      if (res.data?.success) {
        // ✅ Update UI status instead of removing user
        setUsers((prev) =>
          prev.map((u) =>
            u.id === user.id ? { ...u, status: "Inactive" } : u
          )
        );

        setToast({
          message: res.data.message || "User deactivated",
          type: "success",
        });
      } else {
        setToast({
          message: res.data?.message || "Failed to deactivate user",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setToast({
        message: "Something went wrong",
        type: "error",
      });
    }
  };
  const enableUser = async (user) => {
    if (!window.confirm("Activate this user?")) return;

    try {
      const res = await axios.post(apiUrl + "enableUser", {
        userId: user.user_id,
      }, headers_obj);

      if (res.data?.success) {
        // ✅ Update UI status
        setUsers((prev) =>
          prev.map((u) =>
            u.id === user.id ? { ...u, status: "Active" } : u
          )
        );

        setToast({
          message: res.data.message || "User activated",
          type: "success",
        });
      } else {
        setToast({
          message: res.data?.message || "Failed to activate user",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setToast({
        message: "Something went wrong",
        type: "error",
      });
    }
  };



  const handleUpdateUser = async () => {
    try {
      if (!validateForm()) return;
      if (mode === "add") {

        const newUser = {
          first_name: formData.firstName,
          last_name: formData.lastName,
          name: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          role: formData.role,
          branch: formData.branch,
          phone: formData.phone,
          dob: formData.dob,
          status: formData.status,
          user_type: formData.role,
          is_confirmed: "No",
          source: "Email"
        };

        const selectedroles = roles.find(r => r.RoleName === formData.role);
        const apijson = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          role: {
            role_id: selectedroles ? selectedroles.RoleID : "",
            role_name: selectedroles ? selectedroles.RoleName : ""
          },
          branch_id: formData.branch,
          phone: formData.phone,
          dateOfBirth: formData.dob,
        };
        const res = await axios.post(apiUrl + "inviteUser", apijson, headers_obj);
        if (res.data?.success) {
          setToast({ message: res.data.message, type: "success" });
        } else {
          setToast({ message: res.data?.message || "Failed", type: "error" });
        }
        setUsers((prev) => [...prev, newUser]);
      } else if (mode === "edit") {
        setUsers((prev) =>
          prev.map((u) =>
            u.id === selectedUser.id
              ? {
                ...u,
                first_name: formData.firstName,
                last_name: formData.lastName,
                name: `${formData.firstName} ${formData.lastName}`,
                email: formData.email,
                role: formData.role,
                branch: formData.branch,
                phone: formData.phone,
                dob: formData.dob,
                status: formData.status,
              }
              : u
          )
        );
        const res = await axios.put(apiUrl + `/updateUserById/${selectedUser.id}`, {
          firstName: formData.firstName,
          lastName: formData.lastName,
          phone: formData.phone,
          dateOfBirth: formData.dob,
        }, headers_obj);

        if (res.data?.success) {
          setToast({ message: res.data.message, type: "success" });
        } else {
          setToast({ message: res.data?.message || "Failed", type: "error" });
        }

      }
      setOpenModal(false);
      setSelectedUser(null);
      fetchUsers();
      setErrors({});
    } catch (error) {
      console.log(error);
    }
  };

  // const handleBulkDelete = () => {
  //   if (!selectedIds.length) return;
  //   if (window.confirm(`Delete ${selectedIds.length} selected user(s)?`)) {
  //     setUsers(users.filter((u) => !selectedIds.includes(u.id)));
  //     setSelectedIds([]);
  //   }
  // };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedUser(null);
    setErrors({});
  };


  return (
    <>
      {/* ---------- Notification ---------- */}
      <Notification
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "success" })}
      />

      {/* ---------- Loader ---------- */}
      {loader ? (
        <div className="flex items-center justify-center min-h-[60vh] w-full">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-[#22C55E] rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen h-screen overflow-y-auto">


          {/* ---------- Header ---------- */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Users</h1>
              <p className="text-sm text-slate-500">
                Manage users, access and permissions
              </p>
            </div>

            <div className="flex gap-3 w-full sm:w-auto">

              <button
                onClick={() => {
                  setMode("add");
                  setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    role: "",
                    branch: "",
                    phone: "",
                    dob: "",
                    status: "",
                  });
                  setOpenModal(true);
                }}
                className="flex items-center gap-2 bg-[#72398E] text-white px-5 py-2 rounded-xl shadow-md  transition"
              >
                <FiPlus /> Invite User
              </button>
            </div>
          </div>

          {/* ---------- Filter Bar ---------- */}
          <div className="bg-white rounded-xl shadow-md border border-slate-200 p-4 flex flex-col sm:flex-row gap-4 mb-6">
            <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-4 py-2 flex-1 bg-slate-50 focus-within:ring-2 focus-within:ring-slate-900">
              <FiSearch className="text-slate-400" />
              <input
                placeholder="Search name or email"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="bg-transparent outline-none text-sm w-full"
              />
            </div>

            <div className="relative block sm:inline-block w-full sm:w-64">

              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="
      block w-full h-10 px-4 pr-10 rounded-xl 
      border border-slate-300 bg-white text-sm text-gray-700
      shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
      appearance-none
    "
              >
                <option value="All">All Roles</option>
                {roles.map((r) => (
                  <option key={r.RoleID} value={r.RoleName}>{r.RoleName}</option>
                ))}
              </select>

              {/* Custom arrow */}
              <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                <svg
                  className="h-4 w-4 text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          {/* ---------- Desktop Table ---------- */}
          <div className="hidden md:block bg-white rounded-xl shadow-lg overflow-hidden max-h-[60vh] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-100 text-slate-500 uppercase text-xs tracking-wider">
                <tr>
                  <th className="p-4 text-left">User</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Phone</th>
                  <th className="text-center">Verified</th>
                  <th className="text-right pr-6">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {filteredUsers.map((user) => (
                  <tr key={user.id} className="hover:bg-slate-50 transition">
                    <td className="flex items-center gap-3 p-4">
                      <img
                        src={user.avatar}
                        className="w-10 h-10 rounded-xl ring-2 ring-white shadow"
                      />
                      <div>
                        <p className="font-semibold">
                          {user.first_name} {user.last_name}
                        </p>
                        <p className="text-xs text-slate-500">{user.role}</p>
                      </div>
                    </td>
                    <td className="text-center">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${user.status === "Active"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-rose-100 text-rose-600"
                          }`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td className="text-center text-slate-600">{user.email}</td>
                    <td className="text-center text-slate-600">{user.phone || "N/A"}</td>
                    <td className="text-center text-slate-600">
                      {user.is_confirmed === "Yes" ? (
                        <FiCheckCircle className="text-green-500 w-6 h-6 mx-auto" />
                      ) : user.is_confirmed === "No" ? (
                        <FiXCircle className="text-red-500 w-6 h-6 mx-auto" />
                      ) : (
                        <span className="text-gray-400 italic">N/A</span>
                      )}
                    </td>
                    <td className="pr-6 text-right">
                      <div className="flex justify-center pl-10">
                        <Popover
                          placement="bottom-end"
                          trigger={
                            <FiMoreHorizontal className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-800" />
                          }
                        >
                          <button
                            onClick={() => handleView(user)}
                            className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                          >
                            <FiEye /> View
                          </button>

                          <button
                            onClick={() => handleEdit(user)}
                            className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                          >
                            <FiEdit2 /> Edit
                          </button>

                          <button
                            onClick={() =>
                              user.status === "Active"
                                ? handleDelete(user)
                                : enableUser(user)
                            }
                            className={`flex items-center gap-2 w-full px-4 py-2 text-sm ${user.status === "Active"
                              ? "text-rose-600 hover:bg-rose-50"
                              : "text-purple-600 hover:bg-purple-50"
                              }`}
                          >
                            {user.status === "Active" ? <FiXCircle /> : <FiCheckCircle />}
                            {user.status === "Active" ? "Inactive" : "Activate"}
                          </button>
                        </Popover>
                      </div>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>
          </div>


          {/* ---------- Mobile Users Cards ---------- */}
          <div className="md:hidden space-y-4">
            {filteredUsers.length === 0 ? (
              <div className="text-center text-slate-400 py-10">
                No users found
              </div>
            ) : (
              filteredUsers.map((user) => (
                <div
                  key={user.id}
                  className="bg-white rounded-2xl p-4 shadow-md border border-slate-200 hover:shadow-lg transition-shadow duration-200"
                >
                  {/* Top Section with Actions aligned */}
                  <div className="flex items-center justify-between gap-4">
                    {/* User Info */}
                    <div className="flex items-center gap-4 min-w-0">
                      <img
                        src={user.avatar}
                        alt={`${user.first_name} ${user.last_name}`}
                        className="w-14 h-14 rounded-xl ring-2 ring-white shadow"
                      />

                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-slate-900 truncate">
                          {user.first_name} {user.last_name}
                        </p>
                        <p className="text-sm text-slate-500 truncate">{user.email}</p>

                        <div className="flex items-center gap-2 mt-1">
                          <span
                            className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${user.status === "Active"
                              ? "bg-purple-100 text-purple-700"
                              : "bg-rose-100 text-rose-600"
                              }`}
                          >
                            {user.status}
                          </span>

                          {user.is_confirmed === "Yes" ? (
                            <span className="text-purple-700 text-xs font-semibold">Verified</span>
                          ) : user.is_confirmed === "No" ? (
                            <span className="text-rose-600 text-xs font-semibold">Not Verified</span>
                          ) : (
                            <span className="text-gray-400 italic text-xs">N/A</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Actions Icon aligned to top row */}
                    <Popover
                      placement="bottom-end"
                      trigger={
                        <FiMoreHorizontal className="cursor-pointer text-slate-500 hover:text-slate-800" />
                      }
                    >
                      <button
                        onClick={() => handleView(user)}
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                      >
                        <FiEye /> View
                      </button>

                      <button
                        onClick={() => handleEdit(user)}
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                      >
                        <FiEdit2 /> Edit
                      </button>

                      <button
                        onClick={() =>
                          user.status === "Active"
                            ? handleDelete(user)
                            : enableUser(user)
                        }
                        className={`flex items-center gap-2 w-full px-4 py-2 text-sm ${user.status === "Active"
                          ? "text-rose-600 hover:bg-rose-50"
                          : "text-purple-600 hover:bg-purple-50"
                          }`}
                      >
                        {user.status === "Active" ? <FiXCircle /> : <FiCheckCircle />}
                        {user.status === "Active" ? "Inactive" : "Activate"}
                      </button>
                    </Popover>


                  </div>
                </div>
              ))
            )}
          </div>



        </div>
      )}

      {/* ---------- Modal ---------- */}
      <Modal
        open={openModal}
        onClose={closeModal}
        title={
          mode === "view"
            ? "User Profile"
            : mode === "edit"
              ? "Edit User Details"
              : "Invite New User"
        }
        width="w-full sm:w-[95%] md:max-w-2xl" // Increased width for better 2-column layout
      >
        <div className="space-y-8 p-1">

          {/* --- Section 1: Basic Information --- */}
          <div>
            <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
              <span className="w-8 h-[1px] bg-slate-200"></span> Personal Details
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
              <FormInput
                label="First Name"
                value={formData.firstName}
                onChange={(val) => {
                  setFormData((p) => ({ ...p, firstName: val }));
                  setErrors((prev) => ({ ...prev, firstName: null }));
                }}
                placeholder="e.g. John"
                disabled={mode === "view"}
                error={errors.firstName}
              />

              <FormInput
                label="Last Name"
                value={formData.lastName}
                onChange={(val) => {
                  setFormData((p) => ({ ...p, lastName: val }));
                  setErrors((prev) => ({ ...prev, lastName: null }));
                }}
                placeholder="e.g. Doe"
                disabled={mode === "view"}
                error={errors.lastName}
              />

              {!isEditMode && (
                <div className="sm:col-span-2">
                  <FormInput
                    label="Email Address"
                    type="email"
                    value={formData.email}
                    onChange={(val) => {
                      setFormData((p) => ({ ...p, email: val }));
                      setErrors((prev) => ({ ...prev, email: null }));
                    }}
                    placeholder="john.doe@example.com"
                    disabled={mode === "view"}
                    error={errors.email}
                  />
                </div>
              )}

              <FormInput
                label="Mobile Number"
                value={formData.phone}
                onChange={(val) => setFormData((p) => ({ ...p, phone: val }))}
                placeholder="+91 00000 00000"
                disabled={mode === "view"}
              />

              <FormInput
                label="Date of Birth"
                type="date"
                value={formData.dob}
                onChange={(val) => setFormData((p) => ({ ...p, dob: val }))}
                disabled={mode === "view"}
              />
            </div>
          </div>

          {/* --- Section 2: Role & Assignment --- */}
          {!isEditMode && (
            <div>
              <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                <span className="w-8 h-[1px] bg-slate-200"></span> Access & Permissions
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                {/* Role Select */}
                <div className="flex flex-col">
                  <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1">Role</label>
                  <div className="relative group">
                    <select
                      disabled={mode === "view"}
                      value={formData.role || ""}
                      onChange={(e) => setFormData((p) => ({ ...p, role: e.target.value }))}
                      className={`w-full appearance-none bg-white border rounded-xl px-4 py-2.5 text-sm transition-all outline-none cursor-pointer
                  ${errors.role ? "border-rose-400 focus:ring-rose-500/10" : "border-slate-200 focus:ring-purple-500/10"}
                  ${mode === "view" ? "bg-slate-50 text-slate-400 cursor-not-allowed" : "hover:border-slate-300 focus:ring-4 focus:border-purple-500"}
                `}
                    >
                      <option value="" disabled>Select Role</option>
                      {roles.map((r) => (
                        <option key={r.RoleID} value={r.RoleName}>{r.RoleName}</option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-slate-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
                    </div>
                  </div>
                  {errors.role && <span className="text-[10px] text-rose-500 mt-1 ml-1 font-medium">{errors.role}</span>}
                </div>

                {/* Branch Select */}
                <div className="flex flex-col">
                  <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1">Branch</label>
                  <div className="relative group">
                    <select
                      disabled={mode === "view"}
                      value={formData.branch || ""}
                      onChange={(e) => setFormData((p) => ({ ...p, branch: e.target.value }))}
                      className={`w-full appearance-none bg-white border rounded-xl px-4 py-2.5 text-sm transition-all outline-none cursor-pointer
                  ${errors.branch ? "border-rose-400 focus:ring-rose-500/10" : "border-slate-200 focus:ring-purple-500/10"}
                  ${mode === "view" ? "bg-slate-50 text-slate-400 cursor-not-allowed" : "hover:border-slate-300 focus:ring-4 focus:border-purple-500"}
                `}
                    >
                      <option value="" disabled>Select Branch</option>
                      {branch.map((b) => (
                        <option key={b.Branch_ID} value={b.Branch_ID}>{b.Branch_Name}</option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-slate-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
                    </div>
                  </div>
                  {errors.branch && <span className="text-[10px] text-rose-500 mt-1 ml-1 font-medium">{errors.branch}</span>}
                </div>

                {/* Status Select */}
                <div className="flex flex-col sm:col-span-2">
                  <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1">Status</label>
                  <div className="relative group">
                    <select
                      disabled={mode === "view"}
                      value={formData.status || ""}
                      onChange={(e) => setFormData((p) => ({ ...p, status: e.target.value }))}
                      className={`w-full appearance-none bg-white border rounded-xl px-4 py-2.5 text-sm transition-all outline-none cursor-pointer
                  ${errors.status ? "border-rose-400 focus:ring-rose-500/10" : "border-slate-200 focus:ring-purple-500/10"}
                  ${mode === "view" ? "bg-slate-50 text-slate-400 cursor-not-allowed" : "hover:border-slate-300 focus:ring-4 focus:border-purple-500"}
                `}
                    >
                      <option value="" disabled>Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-slate-400">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" /></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* --- Action Buttons --- */}
          <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
            <button
              onClick={closeModal}
              className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors"
            >
              Discard
            </button>

            {mode !== "view" && (
              <button
                onClick={handleUpdateUser}
                className="px-8 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-bold shadow-lg shadow-slate-200 hover:bg-purple-600 transition-all active:scale-95"
              >
                {mode === "edit" ? "Save Changes" : "Invite User"}
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );


}

function FormInput({
  label,
  value,
  onChange,
  placeholder,
  readOnly,
  disabled,
  type = "text",
  error
}) {
  return (
    <div className="flex flex-col">
      <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ""}
        readOnly={readOnly}
        disabled={disabled}   // ✅ apply it here
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
          ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
          ${(readOnly || disabled)
            ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
            : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
        `}
      />
      {error && (
        <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
          {error}
        </span>
      )}
    </div>
  );
}
